export default "__VITE_ASSET__93125adb__"